import { ExtensionReportGenerator } from './extensionReportGenerator';
import type { ExtensionReportFieldVisibility } from './types';
import type { ExtensionReportData } from './types';

export { ExtensionReportGenerator } from './extensionReportGenerator';
export type {
  ExtensionReportData,
  ExtensionReportDocumentDetail,
  ExtensionReportFieldVisibility,
} from './types';

export const generateExtensionReportPDF = async (
  extension: ExtensionReportData,
  userName: string,
  imageBase64: string,
  fieldVisibility?: ExtensionReportFieldVisibility,
): Promise<void> => {
  const generator = new ExtensionReportGenerator({
    userName,
    imageBase64,
    title: 'Reporte Prórroga',
    fileName: `REPORTE-PRORROGA-${extension.id}${extension.folio ? `-${extension.folio}` : ''}.pdf`,
    extension,
    fieldVisibility,
  });

  await generator.generate();
};
